var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "32.5px",
    height: "16.5px",
    viewBox: "0 0 32.5 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "rgb(170, 134, 65)",
    strokeWidth: "1px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fill: "none",
    d: "M0.500,1.500 L31.500,1.500 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "rgb(170, 134, 65)",
    strokeWidth: "1px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fill: "none",
    d: "M0.500,8.500 L31.500,8.500 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "rgb(170, 134, 65)",
    strokeWidth: "1px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fill: "none",
    d: "M11.500,15.500 L31.500,15.500 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutus);
export default __webpack_public_path__ + "static/media/aboutus.feae3be94d578be8f9ba8e5aba4786c3.svg";
export { ForwardRef as ReactComponent };